import React from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "./SectionTitle";

import controlPerson from "../../img/home/control-person.webp";
import controlTablet from "../../img/home/control-tablet.webp";

function FeatureItem({ titleKey, textKey, t, white = false }) {
  return (
    <div className="flex flex-col gap-[15px] max-w-[309px]">
      <div className="flex items-center gap-[15px]">
        <div
          className={`w-[18px] h-[18px] rounded-[2px] flex items-center justify-center shrink-0 ${
            white ? "bg-white" : "bg-[#bfccd7]"
          }`}
        >
          <Check className="w-[12px] h-[12px] text-[#1c385f]" strokeWidth={2.5} />
        </div>
        <span
          className={`font-['Inter'] font-bold text-[14px] lg:text-[16px] ${
            white ? "text-white" : "text-[#1c385f]"
          }`}
        >
          {t(titleKey)}
        </span>
      </div>
      <p
        className={`font-['Inter'] font-normal text-[14px] leading-[1.5] ${
          white ? "text-white" : "text-[#435c7f]"
        }`}
      >
        {t(textKey)}
      </p>
    </div>
  );
}

function MoreControl() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="hidden lg:block">
          <SectionTitle
            title1={t("control.title1")}
            title2={t("control.title2")}
            text={t("control.subtitle")}
            className="mx-auto"
          />
        </div>
        <div className="lg:hidden">
          <SectionTitle
            title1={t("control.title1")}
            title2={t("control.title2")}
            text={t("control.subtitle")}
            align="left"
          />
        </div>

        {/* Desktop: мозаика */}
        <Fade triggerOnce direction="up" duration={700}>
        <div className="hidden lg:block relative mt-[60px] h-[413px]">
          {/* Левая карточка с фото */}
          <div className="absolute left-0 top-0 w-[34.3%] h-full rounded-[25px] overflow-hidden">
            <img
              src={controlPerson}
              alt=""
              aria-hidden
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  "linear-gradient(180deg, rgba(0,0,0,0) 43%, rgba(5,15,23,0.32) 66%, rgba(6,19,30,0.8) 100%)",
              }}
            />
            <div className="absolute left-[44px] bottom-[38px] right-[24px]">
              <FeatureItem titleKey="control.feature1.title" textKey="control.feature1.text" t={t} white />
            </div>
          </div>

          {/* Середина: серый + синий блоки */}
          <div className="absolute left-[34.3%] top-[31px] w-[32.9%] h-[175px] bg-[#f2f2f1] flex items-center px-[27px]">
            <FeatureItem titleKey="control.feature3.title" textKey="control.feature3.text" t={t} />
          </div>
          <div className="absolute left-[34.3%] top-[206px] w-[32.9%] h-[176px] bg-[#1c385f] flex items-center px-[27px]">
            <FeatureItem titleKey="control.feature2.title" textKey="control.feature2.text" t={t} white />
          </div>

          {/* Правая карточка с фото и тёмным оверлеем */}
          <div className="absolute left-[67.2%] top-[31px] right-0 h-[351px] rounded-r-[25px] overflow-hidden">
            <img
              src={controlTablet}
              alt=""
              aria-hidden
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[rgba(10,22,40,0.8)]" />
            <div className="absolute left-[30px] bottom-[30px] right-[24px]">
              <FeatureItem titleKey="control.feature4.title" textKey="control.feature4.text" t={t} white />
            </div>
          </div>
        </div>
        </Fade>

        {/* Mobile / tablet: список преимуществ */}
        <div className="lg:hidden mt-[35px] flex flex-col gap-[35px] sm:grid sm:grid-cols-2">
          <Fade cascade triggerOnce direction="up" damping={0.1}>
            <FeatureItem titleKey="control.feature3.title" textKey="control.feature3.text" t={t} />
            <FeatureItem titleKey="control.feature1.title" textKey="control.feature1.text" t={t} />
            <FeatureItem titleKey="control.feature2.title" textKey="control.feature2.text" t={t} />
            <FeatureItem titleKey="control.feature4.title" textKey="control.feature4.text" t={t} />
          </Fade>
        </div>
      </div>
    </section>
  );
}

export default MoreControl;
